import React, { useEffect, useState } from "react";
import styles from "../styles/applicant/ApplicantDashboard.module.css";
import ApplicantTable from "../components/ApplicantDashboardPage/ApplicantTable";
import ApplicantHeader from "../components/ApplicantDashboardPage/ApplicantHeader";

const ApplicantDashboard = () => {
  
    return (
        <div className={styles.dashboard}>
            <ApplicantHeader />
            <ApplicantTable />
        </div>
    );
};

export default ApplicantDashboard;
